module.exports = __webpack_public_path__ + "static/media/tip1.eaf83a61.svg";